<template>
  <div class="content">
    <div class="text">
      <h2>Schilderwerken <b class="orange">Munsterman</b> is gespecialiseerd in het realiseren van schilderwerkzaamheden.</h2>
    </div>
  </div>
</template>
<script>
export default {

}
</script>
<style lang="scss" scoped>
@import '../assets/css/definitions';
  .content {
    text-align: center;
    width: 100%;
    //height: 100%;
    background: rgb(51, 51, 51);
    //padding-top: 50px;
    padding-top: 7%;
    word-wrap: break-word;
    font-size: 30px;
    .text {
      width: 80%;
      margin-left: 10%;
      padding-bottom: 15px;
      border-bottom: 5px solid $color-acc;
      color: white;
    }
  }

  .orange {
    color: $color-acc;
  }

  @media screen and (max-width: 1024px) {
    .content {
      padding-top: 3%;
      padding-bottom: 3%;
    }
  }

  @media screen and (min-width: 500px) and (max-width: 900px) {
    .content {
      font-size: 25px;
    }
  }

  @media screen and (max-width: 500px) {
    .content {
      font-size: 20px;
    }
  }
</style>


